import { ChangeEvent, KeyboardEvent } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useLibraryContext } from '../../library/context';

type Props = {
  close: () => void,
  onInput: (evt: ChangeEvent<HTMLInputElement>) => void,
}

export const SearchBox = ({ close, onInput }: Props) => {

  const {
    searchboxRef,
    focusedIndex,
    setFocusedIndex,
    searchQuery,
    setSearchQuery,
    sendResourceToLive,
    addResourceToPlaylist,
    previewResource
  } = useLibraryContext();

  useHotkeys(
    'ctrl+f',
    (evt) => {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      searchboxRef.current?.focus();
      searchboxRef.current?.select();
    },
  );

  const handleSearchboxInput = (evt: KeyboardEvent) => {
    if (evt.ctrlKey && !evt.shiftKey && !evt.altKey && evt.key == 'f') {
      evt.preventDefault();
      evt.stopPropagation();
      (evt.target as HTMLInputElement).select();
    }
    else if (evt.key == 'Escape') {
      searchboxRef.current?.blur();
      setFocusedIndex(-1);
      setSearchQuery('');
    }
    else if (evt.key == 'ArrowDown') {
      setFocusedIndex(i => ++i);
    }
    else if (evt.key == 'ArrowUp') {
      setFocusedIndex(i => Math.max(0, --i));
    }
    else if (evt.key == 'Enter') {
      if (evt.ctrlKey && !evt.shiftKey && !evt.altKey) {
        sendResourceToLive(focusedIndex, close);
      }
      else if (evt.shiftKey && !evt.ctrlKey && !evt.altKey) {
        addResourceToPlaylist(focusedIndex);
        // Don't close the modal after this action!
      }
      else if (!evt.altKey && !evt.ctrlKey && !evt.shiftKey) {
        previewResource(focusedIndex, close);
      }
    }
  };

  return (
    <input
      className='relative p-2 rounded-sm w-full z-30'
      onInput={onInput}
      onKeyDown={handleSearchboxInput}
      placeholder='Quick search (Ctrl+F)...'
      ref={searchboxRef}
      value={searchQuery}
    />
  );
};
